import { ClientMonitoring } from '@interfaces/control/monitoring/responses/client-monitoring.response';
import { MonitoringStatusColumn } from '@interfaces/control/monitoring/responses/monitoring-status.response';
import { MonitoringFilterDto } from '@interfaces/control/monitoring/requests/monitoring-filter.request';

export interface MonitoringState {
  clients: ClientMonitoring[];
  statusColumns: MonitoringStatusColumn[];
  loading: boolean;
  error: string | null;
  filters: MonitoringFilterDto | null;
}

export const initialMonitoringState: MonitoringState = {
  clients: [],
  statusColumns: [],
  loading: false,
  error: null,
  filters: null,
};
